import { ByAmount } from './ByAmount';
export default ByAmount;